import { EnvironmentTargetInterface } from '@environments/assets/environment-target.interface';

export const employerApi: EnvironmentTargetInterface = {
  build: {
    baseUrl: 'https://api.arbeidsgiver.fagforbundet.build',
  },
  production: {
    baseUrl: 'https://api.arbeidsgiver.fagforbundet.no',
  },
  staging: {
    baseUrl: 'https://api.arbeidsgiver.fagforbundet.dev',
  },
};
